<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
                  <a-form-model-item prop="duihuanId" >
                        <span slot="label" ><a-tooltip>{{$t('积分金币兑换记录.兑换码id')}}<template slot="title">{{$t('积分金币兑换记录.兑换码id')}}</template></a-tooltip> </span>
                        <a-input v-model="form.duihuanId"  :placeholder="$t('通用.输入.请输入')+'兑换码id'" >
                          <locale-field-button
                              slot="suffix"
                              class="ant-input-suffix-button"
                              v-model="form.localeFieldMap['duihuanId']"
                              input-type="input"
                              table-name="zb_duihuan_jilu"
                              table-field="duihuanId"
                              :field-value="form.duihuanId"/>
                        </a-input>
                  </a-form-model-item>
                  <a-form-model-item prop="duihuanMa" >
                        <span slot="label" ><a-tooltip>{{$t('积分金币兑换记录.兑换码')}}<template slot="title">{{$t('积分金币兑换记录.兑换码')}}</template></a-tooltip> </span>
                        <a-input v-model="form.duihuanMa" :maxLength="30" :placeholder="$t('通用.输入.请输入')+'兑换码'" >
                          <locale-field-button
                              slot="suffix"
                              class="ant-input-suffix-button"
                              v-model="form.localeFieldMap['duihuanMa']"
                              input-type="input"
                              table-name="zb_duihuan_jilu"
                              table-field="duihuanMa"
                              :field-value="form.duihuanMa"/>
                        </a-input>
                  </a-form-model-item>
                  <a-form-model-item prop="duihuanNum" >
                        <span slot="label" ><a-tooltip>{{$t('积分金币兑换记录.兑换数量')}}<template slot="title">{{$t('积分金币兑换记录.兑换数量')}}</template></a-tooltip> </span>
                        <a-input v-model="form.duihuanNum"  :placeholder="$t('通用.输入.请输入')+'兑换数量'" >
                          <locale-field-button
                              slot="suffix"
                              class="ant-input-suffix-button"
                              v-model="form.localeFieldMap['duihuanNum']"
                              input-type="input"
                              table-name="zb_duihuan_jilu"
                              table-field="duihuanNum"
                              :field-value="form.duihuanNum"/>
                        </a-input>
                  </a-form-model-item>
                  <a-form-model-item prop="type" >
                        <span slot="label" ><a-tooltip>{{$t('积分金币兑换记录.兑换类型(1,积分 2,金币)')}}<template slot="title">{{$t('积分金币兑换记录.兑换类型(1,积分 2,金币)')}}</template></a-tooltip> </span>
                  </a-form-model-item>
                  <a-form-model-item prop="userId" >
                        <span slot="label" ><a-tooltip>{{$t('积分金币兑换记录.用户id')}}<template slot="title">{{$t('积分金币兑换记录.用户id')}}</template></a-tooltip> </span>
                        <a-input v-model="form.userId"  :placeholder="$t('通用.输入.请输入')+'用户id'" >
                          <locale-field-button
                              slot="suffix"
                              class="ant-input-suffix-button"
                              v-model="form.localeFieldMap['userId']"
                              input-type="input"
                              table-name="zb_duihuan_jilu"
                              table-field="userId"
                              :field-value="form.userId"/>
                        </a-input>
                  </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getDuihuanJilu, addDuihuanJilu, updateDuihuanJilu } from '@/api/duihuan/duihuanJilu'
  import {mapGetters} from 'vuex'
  import CustomDictTag from "@/components/DictCustomTag";
  import {generateFilePath, uploadObject} from "@/api/tool/oss";
  import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";


  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
                          id: null,
                          duihuanId: null,
                          duihuanMa: null,
                          duihuanNum: null,
                          type: null,
                          userId: null,
        localeFieldMap:{},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
                              duihuanId: [{ required: true, message: this.$t('积分金币兑换记录.兑换码id')+this.$t('通用.文本.不能为空'), trigger: 'blur' }] ,
                              duihuanMa: [{ required: true, message: this.$t('积分金币兑换记录.兑换码')+this.$t('通用.文本.不能为空'), trigger: 'blur' }] ,
                              userId: [{ required: true, message: this.$t('积分金币兑换记录.用户id')+this.$t('通用.文本.不能为空'), trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
                          id: null,
                          duihuanId: null,
                          duihuanMa: null,
                          duihuanNum: null,
                          type: null,
                          userId: null,
        localeFieldMap:{},
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDuihuanJilu({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateDuihuanJilu(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addDuihuanJilu(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
